
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/tiempo",
      function () {
        return require("private-next-pages/[region]/[resort]/tiempo.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/tiempo"])
      });
    }
  